import React, { PropsWithChildren } from 'react';
import { type VariantProps } from 'class-variance-authority';

import getCtaStyles from './get-cta-styles';

export interface ButtonProps
	extends React.ButtonHTMLAttributes<HTMLButtonElement>,
		VariantProps<typeof getCtaStyles> {
	icon?: React.ReactNode;
	iconPosition?: 'start' | 'end';
	isLoading?: boolean;
}

export default function Button({
	icon,
	iconPosition = 'end',
	isLoading = false,
	className,
	intent,
	size,
	inverse,
	type = 'button',
	children,
	...props
}: PropsWithChildren<ButtonProps>) {
	const hasIcon = Boolean(icon);
	return (
		<button
			type={type}
			className={getCtaStyles({
				intent,
				isLoading,
				size,
				hasIcon,
				iconPosition,
				inverse,
				className,
			})}
			{...props}
		>
			{children}
			{icon}
		</button>
	);
}
